import { Routes, Route } from 'react-router-dom';
import Signup from 'screens/Signup/Signup';
import Code from 'screens/Code/Code';
import Main from 'screens/Main/Main';
import RideStart from 'screens/RideStart/RideStart';
import Qr from 'screens/Qr/Qr';
import Ride from 'screens/Ride/Ride';
import Alerts from 'components/Alerts/Alerts';
import PrivateRoute from 'components/PrivateRoute/PrivateRoute';
import ScooterShow from 'screens/ScooterShow/ScooterShow';
import Parking from 'screens/Parking/Parking';
import AddFunds from 'screens/AddFunds/AddFunds';
import styles from './Root.module.scss';

export default function Root() {
  return (
    <div className={styles.container}>
      <Routes>
        <Route index element={<PrivateRoute><Main /></PrivateRoute>} />
        <Route path="/auth" element={<Signup />} />
        <Route path="/auth/code" element={<Code />} />
        <Route path="/ride" element={<PrivateRoute><Ride /></PrivateRoute>} />
        <Route path="/ride/create" element={<PrivateRoute><RideStart /></PrivateRoute>} />
        <Route path="/ride/create/qr" element={<PrivateRoute><Qr /></PrivateRoute>} />
        <Route path="/scooters/:id" element={<ScooterShow />} />
        <Route path="/parking/:id" element={<PrivateRoute><Parking /></PrivateRoute>} />
        <Route path="/funds" element={<PrivateRoute><AddFunds /></PrivateRoute>} />
      </Routes>
      <Alerts />
    </div>
  );
}
